import { WaterFlowPressure } from '../water-flow-pressure.dto';
import { InspectionCase } from './inspection-case.dto';

export class InspectionWaterSupplyDataCaseDto extends InspectionCase {
  pressure?: number = 0; // psi
  staticPressure?: number = 0; // psi
  residualPressure?: number = 0; // psi
  nominalPressure?: number = 0; // psi
  flowRate?: number = 0; // gpm
  poolingVolume?: number = 0; // m^3
  waterFlowPressure?: WaterFlowPressure; // 450gpm@85.2psi
  incomingPressure?: number = 0; // psi
  outgoingPressure?: number = 0; // psi
}
export class InspectionWaterSupplyDataCase extends InspectionWaterSupplyDataCaseDto {
  constructor(data: InspectionWaterSupplyDataCaseDto = {}) {
    super(data);
    this.pressure = data.pressure;
    this.staticPressure = data.staticPressure;
    this.residualPressure = data.residualPressure;
    this.nominalPressure = data.nominalPressure;
    this.flowRate = data.flowRate;
    this.poolingVolume = data.poolingVolume;
    this.waterFlowPressure = new WaterFlowPressure(data.waterFlowPressure);
    this.incomingPressure = data.incomingPressure;
    this.outgoingPressure = data.outgoingPressure;
  }
}
